import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

const MenuItem = ({ title, showCount, active, count, destination }) => {
  return (
    <MenuItem.ItemTitle active={active} to={destination}>
      {active && `> `}
      {title}
      {showCount && <MenuItem.Count active={active}>{count || 0}</MenuItem.Count>}
    </MenuItem.ItemTitle>
  );
};

MenuItem.ItemTitle = styled(Link)`
  height: 49px;
  width: 100%;
  color: ${(props) => (props.active ? COLORS.primaryText : COLORS.secondaryText)};
  font-family: ${(props) => (props.active ? FONTS.emphasized : FONTS.default)};
  font-size: 18px;
  font-weight: ${(props) => (props.active ? 500 : 400)};
  line-height: 22px;
  padding: 12px 24px 12px 32px;
  display: flex;
  justify-content: space-between;
  text-align: left;
  background-color: ${COLORS.primaryBackground};

  &:focus {
    color: ${COLORS.primaryText};

    div {
      color: ${COLORS.primaryText};
      border: 1px solid ${COLORS.primaryMenuItemCountBorder};
    }
  }

  &:hover {
    font-family: ${(props) => (props.active ? FONTS.emphasized : FONTS.default)};
    color: ${COLORS.primaryText};
  }
`;

MenuItem.Count = styled.div`
  width: 30px;
  height: 30px;
  line-height: 15px;
  font-family: ${FONTS.default};
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -5px;
  color: ${(props) => (props.active ? COLORS.primaryText : COLORS.secondaryText)};
  border: ${(props) =>
    props.active
      ? `1px solid ${COLORS.primaryMenuItemCountBorder}`
      : `1px solid ${COLORS.secondaryMenuItemCountBorder}`};
`;

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  showCount: PropTypes.bool,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  count: PropTypes.number,
};

export default MenuItem;
